import { useMemo, useRef } from "react";
import {  Rectangle, Pane, TileLayer } from "react-leaflet";

// Global
import { outerBounds } from "../utils/Global";


// Styles
import { layersStyle } from "../utils/Theme";

export function TilePane(): JSX.Element {
    return(
        <Pane name="custom" style={{ zIndex: -1000 }}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; <a href=&quot;https://www.openstreetmap.org/copyright&quot;>OpenStreetMap</a> contributors"
            />
        </Pane>
    )
}

export function BackgroundPane(): JSX.Element {

    const rectRef = useRef<L.Rectangle>(null);

    // on Click Rectangle - Resets the zoom and full screen to the us map
    // const onClickRect = useMemo(
    //     () => ({
    //         click() {
    //         
    //         }
    //     }),
    //     [geoJsonId]
    // );

    return(
        <Pane name="background-pane" style={{ zIndex: -100 }}>
            <Rectangle bounds={outerBounds} pathOptions={layersStyle.greyOut} 
            // eventHandlers={onClickRect} 
            ref={rectRef}/>
        </Pane>
    )
}
